<ng-container *ngIf="notification">
    <ds-notification
        theme="warning"
        [header]="'Warning - Trip ID ' + notification.trip"
        [content]="notification.notificationDetail"
        [hasSnooze]="true"
        [snoozeOptions]="snoozeTimeRange"
        (viewClick)="onViewServiceRequest()"
        (dismissClick)="closeNotification()"
        (snoozeSelect)="onSnoozeSelect($event)"
    ></ds-notification>
</ng-container>
